export default __webpack_public_path__ + "static/loading-2x-speed-34cc66deaf9b89d3bb9913383e05a6eb.gif";